const TEMPLATES = {
  HOME: "Home",
  TOPIC: "Topic",
  SUB_TOPIC: "Sub-Topic",
  SECTION: "Section",
  FAQ: "FAQ",
};

const MODIFY_ELEMENT = {
  HIDE: "hide",
  FULL: "full",
  PARTIAL: "partial",
};

const ELEMENT = {
  ICON: "icon",
  TITLE: "title",
  HEADING: "heading",
  LIST: "list",
  SPAN: "span",
  CONTENT: "content",
  FEATURED_IMAGE: "featured-image",
  ITEM: "item",
  EXCERPT: "excerpt",
  CHILD_PAGE: "child-page",
  CHILD_PAGE_ID: "child-page-id",
};
const CLASSES = { MODIFY_ELEMENT, ELEMENT };

const TEMPLATE_PATHS = {
  [TEMPLATES.HOME]: "./src/templates/Home/home.js",
  [TEMPLATES.TOPIC]: "./src/templates/Topic/topic.js",
  [TEMPLATES.SUB_TOPIC]:
    "./src/templates/SubTopic/subTopic.js",
  [TEMPLATES.SECTION]: null,
  [TEMPLATES.FAQ]: "./src/templates/FAQ/faq.js",
  [TEMPLATES.DEFAULT]: null,
};

const TEMPLATES_URI = {
  HOME: "/",
  EMPTY: "",
  DRAFT: /^\/..\/\?/,
  SEPERATOR: "/",
};

const PAGE_STATUS = {
  DRAFT: "draft",
  PUBLISH: "publish",
};
const isRunningOnBrowser = () =>
  typeof window !== "undefined";

module.exports = {
  TEMPLATES,
  TEMPLATE_PATHS,
  CLASSES,
  TEMPLATES_URI,
  PAGE_STATUS,
  isRunningOnBrowser,
};
